module.exports = __webpack_public_path__ + "assets/img/3.48a5dc09.png";